import { useMemo } from "react"

import { getVariantKeyAttributes } from "entities/products/lib/getProductType"
import { isVariantKey } from "entities/products/lib/isVariantKey"

import { ProductSearchResult } from "../types/GlobalSearch"
import { useArticleNumberSearch } from "./useArticleNumberSearch"
import { useProductObjSearch } from "./useProductObjSearch"
import { useVariantKeySearch } from "./useVariantKeySearch"

interface UseProductSearchArgs {
  searchTerm?: string | null
}

export function useProductSearch({ searchTerm }: UseProductSearchArgs) {
  const articleNumberSearch = useArticleNumberSearch({ searchTerm })
  const productObjSearch = useProductObjSearch({ searchTerm })
  const variantKeySearch = useVariantKeySearch({ searchTerm })

  const results = useMemo<ProductSearchResult[]>(() => {
    if (
      searchTerm &&
      variantKeySearch.results.length > 0 &&
      isVariantKey(searchTerm) &&
      getVariantKeyAttributes(searchTerm).length > 1
    ) {
      return variantKeySearch.results
    }
    if (articleNumberSearch.results.length > 0) {
      return articleNumberSearch.results
    }
    return productObjSearch.results
  }, [
    searchTerm,
    articleNumberSearch.results,
    variantKeySearch.results,
    productObjSearch.results
  ])

  return {
    results,
    isLoading:
      variantKeySearch.isLoading ||
      articleNumberSearch.isLoading ||
      productObjSearch.isLoading
  }
}
